import React from 'react';
import './MenuPrincipal.css';

const MenuPrincipal = (props) => {

    let itemsMenu = [];

    if (props.menu){
        itemsMenu=props.menu.map((e,i)=>{
            return <div key={i} className={i==props.itemSeleccionado?"item-menu-seleccionado":""}
            onClick={()=>props.seleccionar(i)}>
            {e.nombre}
            </div>
        })
    }

    return (
    <div className="menu-principal">
        {itemsMenu}
    </div>
    )
}

export default MenuPrincipal;